import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid } from "@material-ui/core";
import { getIsSubmittingFeedback } from "@icarius-pages/myPersonalData/selectors";
import { sendMyDataFeedbackAction } from "@icarius-pages/myPersonalData/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import { CloseIcon } from "@icarius-icons";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";

const CorrectionDialog = ({ isOpen, onClose }) => {
  const [correctionMessage, setCorrectionMessage] = useState("");
  const dispatch = useDispatch();
  const isSubmittingCorrection = useSelector(getIsSubmittingFeedback);

  const handleClose = () => {
    setCorrectionMessage("");
    onClose();
  };

  const handleSubmit = async () => {
    const success = await dispatch(sendMyDataFeedbackAction({ message: correctionMessage }));
    if (success) {
      handleClose();
    }
  };

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={isOpen}
      scroll={"paper"}
      fullWidth
      maxWidth={"sm"}
      onClose={handleClose}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("requestCorrection")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <Typography style={{ marginBottom: 20 }}>
          {getLocalizedString("detailCorrectionRequest")}
        </Typography>
        <Grid container item alignItems="center" xs={12} style={{ padding: "10px 10px" }}>
          <TextFieldMultiline
            autoFocus
            fullWidth
            label={getLocalizedString("correctionRequest")}
            rows={5}
            margin={"none"}
            value={correctionMessage}
            onChange={(e) => setCorrectionMessage(e.target.value)}
            disabled={isSubmittingCorrection}
            inputProps={{ spellCheck: 'false', maxLength: 250 }}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction
          disabled={isSubmittingCorrection}
          onClick={handleClose}
          text={getLocalizedString("disagree")}
        />
        <ButtonDialogAction
          onClick={handleSubmit}
          isAccept
          text={getLocalizedString("agree")}
          disabled={!correctionMessage.trim() || isSubmittingCorrection}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CorrectionDialog;
